<script>
  export default {
    methods: {
      $disabled () {
        return this.$store.getters.getDisableBtn
      },
    },
  }
</script>
